import styled from "styled-components";

export const DropdownMenu = styled.div`
  position: relative;
  width: 426px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.surface.surfaceOutline};
  background-color: ${({ theme }) => theme.colors.surface.surface};
  box-shadow: #0000001A 0px 0px 15px;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  padding: 6px 6px 2px 6px;

  .row {
    width: 100%;
    height: 38px;
    display: flex;
    flex-direction: row;
    align-items: center;
    background-color: transparent;
    border: none;
    border-radius: 6px;
    padding: 0 6px;
    gap: 8px;
    cursor: pointer;

    .iconContainer {
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 4px;
      border-radius: 50%;
      background-color: ${({ theme }) => theme.colors.secondary.secondary};

      .icon {
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
      }
    }

    .textHeader {
      font-size: 12px;
      font-weight: 400;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.surface.onSurface};
    }
    
    &:hover {
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
    }
  }
`;

export const MainContent = styled.div`
  height: auto;
  max-height: 244px;
  display: flex;
  flex-direction: column;
  padding: 2px 6px 6px 6px;
  overflow-y: auto;
  gap: 4px;

  .item {
    width: 100%;
    height: 38px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: transparent;
    border: none;
    border-radius: 6px;
    padding: 0 6px;
    cursor: pointer;

    .left {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;

      .LeftContent {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 2px;

        .LeftContentName {
          font-size: 12px;
          font-weight: 400;
          line-height: 16px;
          color: ${({ theme }) => theme.colors.surface.onSurface};
        }

        .LeftContentEmail {
          font-size: 10px;
          font-weight: 400;
          line-height: 16px;
          color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
        }
      }
    }

    .right {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;

      .tag {
        height: 16px;
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 0 4px;
        gap: 4px;
        border-radius: 4px;
        background-color: ${({ theme }) => theme.colors.secondary.secondary};

        font-size: 10px;
        font-weight: 600;
        line-height: 12px;
        color: ${({ theme }) => theme.colors.secondary.onSecondary};

        .tagIconContainer {
          width: 12px;
          height: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          
          .tagIcon {
            color: ${({ theme }) => theme.colors.secondary.onSecondaryVariant} !important;
          }
        }
      }
    }
    
    &:hover {
      background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
    }
  }
`;

export const EmptyContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 6px;
  gap: 8px;
  background: ${({ theme }) => theme.colors.surface.surface};

  .iconEmpty {
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  }

  .textEmpty {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  }
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 6px 12px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceContainer};

  .textFooter {
    font-size: 10px;
    font-weight: 400;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
  }
`;
